import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

const TYPE_LABELS: Record<string, string> = {
  invoice: 'Нэхэмжлэх', payment: 'Төлбөр', overdue: 'Хугацаа хэтэрсэн',
  meter_reminder: 'Тоолуур', poll: 'Санал асуулга', announcement: 'Зарлал', system: 'Систем',
};

const TYPE_COLORS: Record<string, string> = {
  invoice: '#3b82f6', payment: '#10b981', overdue: '#ef4444',
  meter_reminder: '#f59e0b', poll: '#8b5cf6', announcement: '#236844', system: '#6b7280',
};

export default function NotificationsPage() {
  const [notifications, setNotifications] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [showAnnounce, setShowAnnounce] = useState(false);
  const [filter, setFilter] = useState('');
  const [form, setForm] = useState({ title: '', body: '' });
  const [sending, setSending] = useState(false);
  const [message, setMessage] = useState('');

  const load = (type?: string) => {
    setLoading(true);
    const params = type ? `?notification_type=${type}` : '';
    api.get(`/admin/notifications${params}`)
      .then(res => { setNotifications(res?.items || []); setTotal(res?.total || 0); })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const handleFilter = (type: string) => {
    setFilter(type);
    load(type || undefined);
  };

  const handleSendAnnouncement = async (e: React.FormEvent) => {
    e.preventDefault();
    setSending(true);
    try {
      const res = await api.post('/admin/notifications/announce', form);
      setMessage(res?.message || 'Зарлал илгээгдлээ');
      setShowAnnounce(false);
      setForm({ title: '', body: '' });
      load(filter || undefined);
    } catch {
      setMessage('Алдаа гарлаа');
    } finally {
      setSending(false);
      setTimeout(() => setMessage(''), 3000);
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h2 style={{ fontFamily: "'Inter'", fontWeight: 700, color: '#1c2b22' }}>
          Мэдэгдэл <span style={{ fontWeight: 400, fontSize: 16, color: '#5f6f66' }}>({total})</span>
        </h2>
        <button onClick={() => setShowAnnounce(!showAnnounce)} style={btnPrimary}>
          {showAnnounce ? 'Болих' : '+ Зарлал илгээх'}
        </button>
      </div>

      {message && (
        <div style={{ background: '#dcfce7', color: '#166534', padding: '10px 16px', borderRadius: 8, marginBottom: 16, fontSize: 14 }}>
          {message}
        </div>
      )}

      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        <button onClick={() => handleFilter('')} style={filterBtn(filter === '')}>Бүгд</button>
        {Object.entries(TYPE_LABELS).map(([key, label]) => (
          <button key={key} onClick={() => handleFilter(key)} style={filterBtn(filter === key)}>{label}</button>
        ))}
      </div>

      {showAnnounce && (
        <div style={card}>
          <h3 style={{ fontFamily: "'Inter'", fontWeight: 600, marginBottom: 16, color: '#236844' }}>Шинэ зарлал</h3>
          <form onSubmit={handleSendAnnouncement}>
            <div style={{ marginBottom: 12 }}>
              <label style={labelStyle}>Гарчиг</label>
              <input value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} style={inputStyle} required placeholder="Зарлалын гарчиг" />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={labelStyle}>Агуулга</label>
              <textarea value={form.body} onChange={e => setForm({ ...form, body: e.target.value })} style={{ ...inputStyle, minHeight: 100, resize: 'vertical' }} required placeholder="Зарлалын дэлгэрэнгүй..." />
            </div>
            <button type="submit" disabled={sending} style={{ ...btnPrimary, opacity: sending ? 0.6 : 1 }}>
              {sending ? 'Илгээж байна...' : 'Бүх оршин суугчдад илгээх'}
            </button>
          </form>
        </div>
      )}

      {loading ? <p>Уншиж байна...</p> : (
        <div style={card}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid #e8e5dc', textAlign: 'left' }}>
                <th style={th}>Төрөл</th>
                <th style={th}>Гарчиг</th>
                <th style={th}>Агуулга</th>
                <th style={th}>Суваг</th>
                <th style={th}>Уншсан</th>
                <th style={th}>Огноо</th>
              </tr>
            </thead>
            <tbody>
              {notifications.map((n: any) => (
                <tr key={n.id} style={{ borderBottom: '1px solid #e8e5dc' }}>
                  <td style={td}>
                    <span style={{
                      background: (TYPE_COLORS[n.type] || '#6b7280') + '20',
                      color: TYPE_COLORS[n.type] || '#6b7280',
                      padding: '2px 8px', borderRadius: 4, fontSize: 12, fontWeight: 600,
                    }}>
                      {TYPE_LABELS[n.type] || n.type}
                    </span>
                  </td>
                  <td style={td}><strong>{n.title}</strong></td>
                  <td style={{ ...td, maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{n.body || '-'}</td>
                  <td style={td}>{n.channel === 'push' ? 'Push' : n.channel === 'sms' ? 'SMS' : 'Апп'}</td>
                  <td style={td}>
                    <span style={{
                      width: 8, height: 8, borderRadius: '50%', display: 'inline-block',
                      background: n.is_read ? '#10b981' : '#f59e0b',
                    }} />
                  </td>
                  <td style={{ ...td, fontSize: 12, color: '#5f6f66' }}>{n.created_at ? new Date(n.created_at).toLocaleString('mn-MN') : '-'}</td>
                </tr>
              ))}
              {notifications.length === 0 && (
                <tr><td colSpan={6} style={{ ...td, textAlign: 'center', color: '#94a3b8' }}>Мэдэгдэл байхгүй</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function filterBtn(active: boolean): React.CSSProperties {
  return {
    padding: '6px 14px', border: 'none', borderRadius: 6, cursor: 'pointer',
    background: active ? '#236844' : '#e8e5dc', color: active ? '#fff' : '#2a3b32',
    fontSize: 13, fontWeight: 500,
  };
}

const btnPrimary: React.CSSProperties = {
  background: 'linear-gradient(180deg, #2f7d52, #236844)', color: '#fff', border: 'none', padding: '8px 20px',
  borderRadius: 10, cursor: 'pointer', fontWeight: 600, fontSize: 14, fontFamily: "'Inter'",
};
const card: React.CSSProperties = {
  background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.06)', marginBottom: 16,
};
const labelStyle: React.CSSProperties = { display: 'block', marginBottom: 4, fontSize: 13, color: '#2a3b32', fontWeight: 500 };
const inputStyle: React.CSSProperties = {
  width: '100%', padding: '8px 12px', border: '1.5px solid #dcdacf', borderRadius: 10, fontSize: 14, boxSizing: 'border-box', background: '#fbfaf6',
};
const th: React.CSSProperties = { padding: '10px 12px', fontSize: 13, color: '#5f6f66', fontWeight: 600 };
const td: React.CSSProperties = { padding: '10px 12px', fontSize: 14, color: '#1c2b22' };
